import * as React from 'react';
export const popularSvg = React.forwardRef(function popularSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#CF102D',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.366 22.382v-6.04c2.848 1.466 2.589 4.746 0 6.04Zm0-7.162V9.522c2.502.95 2.934 4.23 0 5.696Zm3.279-2.072c-.345 1.726-1.726 2.589-1.726 2.589.26.173 1.467 1.036 1.726 2.589v-5.178Zm1.554-6.732c3.538 2.244 3.797 9.148 0 11.824V6.416Zm3.883 21.662V14.356c-.69 3.366-2.934 5.006-3.797 5.524v7.594c1.208.345 2.416.604 3.797.604ZM17.55 5.553c4.055 2.503 3.883 9.752 0 12.514V5.553Zm3.883 21.231v-11.91c-.95 2.848-2.934 4.401-3.797 4.92v8.111c1.294-.172 2.589-.517 3.797-1.121Zm-.086-21.489c-1.036-.518-2.158-.95-3.366-1.122 1.726 1.122 2.848 2.502 3.366 4.315V5.295ZM22.9 7.452c2.762 1.985 3.28 7.077 0 9.666V7.452ZM12.371 4.518c1.985 1.64 3.28 3.452 3.711 5.782V4c-1.294 0-2.589.173-3.71.518Zm-1.639 6.99v-6.3c-1.381.69-2.59 1.64-3.625 2.676 1.294.431 3.193 1.553 3.625 3.624ZM5.899 22.382V9.61C4.69 11.422 4 13.666 4 15.996s.69 4.574 1.899 6.386Zm1.294 1.64h-.086a13.536 13.536 0 0 0 3.538 2.762v-6.818c-.345 1.985-1.726 3.365-3.28 3.97 0 0-.086.086-.172.086ZM22.9 18.499v7.335a9.166 9.166 0 0 0 2.503-2.33L22.9 18.5Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M26.525 12.63c0 2.59-1.295 4.143-2.33 5.178l2.157 4.315c1.122-1.812 1.726-3.883 1.64-6.127 0-2.503-.777-4.833-2.158-6.818.432.95.69 2.071.69 3.452Z',
      fill: '#fff',
    }),
  );
});
popularSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var popular = {
  category: 'brand',
  colorable: false,
  name: 'popular',
  svg: popularSvg,
};
